"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var fetchAndRefreshPersona_1 = require("./fetchAndRefreshPersona");
var synchronizeSearchFolder_1 = require("./synchronizeSearchFolder");
var datapoints_1 = require("../../datapoints");
var owa_analytics_1 = require("owa-analytics");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var owa_trace_1 = require("owa-trace");
var legacy_1 = require("satcheljs/lib/legacy");
// When user click on exiting favorite persona we want to update search folder if needed - if emails/display name has changed
exports.default = legacy_1.action('onFavoritePersonaSelected', datapoints_1.default.OnFavoritePersonaSelectedAction)(legacy_1.select({
    favoritesPersonaNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes; },
})(function onFavoritePersonaSelected(personaId, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var persona, error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    persona = state.favoritesPersonaNodes.get(personaId);
                    if (!!persona.isSyncUpdateDone) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetchAndRefreshPersona_1.default(persona.id, persona.mainEmailAddress, persona.displayName)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, synchronizeSearchFolder_1.default(persona)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    _a = datapoints_1.default.UpdatePersonaAndSearchFolderFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString()));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=onFavoritePersonaSelected.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/onFavoritePersonaSelected.js
// module id = 4649
// module chunks = 14